import * as React from 'react';
import phone from 'one-ui-svg/svg/big-phone.svg';
import { useCtx } from 'one-ui-provider';

import {
  Props,
} from 'one-ui';

import { Image_URL } from 'one-ui-image';

export interface NoCallProps extends Props {
  count?: number;
  ani?: string;
}
/**
 *
 * @param props contains the provider count and phone number of caller(ANI).
 */
export const NoCall = ({
  count,
  ani
}: NoCallProps) => {
  const { resolver, static_resource_url } = useCtx();
  return (
    <div className="new-callprovider">
      <div className="new-callprovider__box">
      <img src={Image_URL(resolver(phone), `${static_resource_url}big-phone.70bd5fb0.svg`)} className="new-callprovider__ico" alt="phone ico"draggable="false" />
        <h3 className="new-callprovider__title">Waiting for a new interaction....</h3>
        <br />
        <br />
        <br />
      </div>

    </div>
  )
}